<template>
  <div class="" :class="{'stat-ligne' : isTotal, 'is-radius-large': !isTotal}">
    <div v-if="!isTotal" class="is-radius-top-left-large is-radius-top-right-large"></div>
    <div class="columns is-gapless">
      <div class="column columns is-2 is-vcentered">
        <div class="column is-7 is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <strong class="entityName" :class="{'is-size-6': !istotal}">{{sale.seller_name}}</strong><br>
        </div>
        <div class="column is-5 is-padding-left-small is-padding-right-small is-padding-top-small is-padding-bottom-small">
          <span class="has-text-grey is-size-6">{{sale.company_name}}</span>
        </div>
      </div>
      <div class="columns column is-6 is-vcentered">
        <div v-if="isDistributeurMode" class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span class="is-size-6">{{sale.promoteur_name}}</span>
          <br>
        </div>
        <div class="column is-3 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span class="is-size-6" v-if="!isTotal">{{sale.program_name}}</span>
          <br>
        </div>
        <div class="column is-1 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span class="is-size-6" v-if="!isTotal">{{sale.lot_ref}}</span>
          <br>
        </div>
      <!-- </div>
      <div class="columns column is-3 is-vcentered"> -->
        <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span class="is-size-6">{{sale.buyer_name}}</span>
          <br>
        </div>
        <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          v-if="!isTotal">
          <span class="is-size-6">{{sale.origin_name}}</span>
          <br>
        </div>
        <div class="column is-2 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
          v-else>
          Total ventes<br>
          <b>{{sale.sale_count}}</b>
          <br>
        </div>
        <div class="column is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small"
             :class="{'is-2': isDistributeurMode, 'is-5': isPromoteurMode}">
          <span v-if="isTotal">Total prix immo<br></span>
          <stat-value v-if="sale.sale_price_with_discount" :value="sale.sale_price_with_discount" :euro="true" :total="isTotal" :class="{'has-text-weight-bold':isTotal}"></stat-value>
          <span v-else>--</span>
          <br>
        </div>
      </div>
      <div class="columns column is-4 is-border-left" :class="{'has-bg-light': !isTotal}">
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Com Vendeur<br></span>
          <stat-value v-if="sale.seller_com" :value="sale.seller_com" :euro="true" :total="isTotal" :class="{'has-text-weight-bold':isTotal}"></stat-value>
          <span v-else>--</span>
          <br>
        </div>
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Com Société<br></span>
          <stat-value v-if="sale.company_com" :value="sale.company_com" :euro="true" :total="isTotal" :class="{'has-text-weight-bold':isTotal}"></stat-value>
          <span v-else>--</span>
          <br>
        </div>
        <div class="column is-4 is-th is-paddingless-right is-padding-bottom-small is-padding-top-small is-padding-left-small">
          <span v-if="isTotal">Total CA<br></span>
          <stat-value v-if="sale.CA" :value="sale.CA" :euro="true" :total="isTotal" :class="{'has-text-weight-bold':isTotal}"></stat-value>
          <span v-else>--</span>
          <br>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import VariationIndice from '../../utils/VariationIndice'
  import StatValue from '../../utils/StatValue'

  export default {
    name: 'SaleRow',
    props: {
      sale: {
        type: Object,
        required: true
      },
      isTotal: {
        type: Boolean,
        default: false
      }
    },
    components: {
      VariationIndice,
      StatValue
    },
    data () {
      return {}
    },
    computed: {
      ...mapGetters(['isDistributeurMode', 'isPromoteurMode'])
    },
    methods: {}
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/statistics/sale/SaleRow.vue